import styled from 'styled-components';
import addAlpha from 'utils/addAlpha';
import { ResponsiveContainer } from 'recharts';

export const Wrapper = styled(ResponsiveContainer)`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 1rem;
  background-color: ${({ theme }) => theme.colors.white};

  .recharts-surface {
    padding: 2rem 0rem 1rem 1rem;
  }

  .recharts-cartesian-axis-line {
    stroke: ${({ theme }) => theme.colors.gray2};
  }

  .recharts-text {
    color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.8)};
    font-size: 1.0625rem;
    line-height: 1.5rem;
  }

  .recharts-cartesian-axis-tick-line {
    display: none;
  }

  .recharts-reference-line {
    stroke-dasharray: 10 10;
  }

  .recharts-reference-line text {
    font-size: 1.0625rem;
    line-height: 1.5rem;
    font-weight: 600;
    text-align: right;
  }

  .recharts-reference-line line {
    stroke-width: 0.125rem;
  }

  circle {
    visibility: hidden;
    :first-child,
    :last-child {
      visibility: visible;
      r: 0.45rem;
      fill-opacity: 1;
      stroke-width: 2;
      stroke: ${({ theme }) => theme.colors.white};
    }
  }

  .recharts-layer path {
    stroke-width: 0.25rem;
  }
`;

export const LegendRowContainer = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 1rem;
  height: 3rem;
  margin-left: 1.5rem;
`;

export const NameContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 1rem;
`;

export const ColoredDot = styled.div`
  background-color: ${(props) => props.color};
  border-radius: 50%;
  width: 0.7rem;
  height: 0.7rem;
  margin-right: 0.75rem;
`;
